import { render, staticRenderFns } from "./matching-schedule-buyer.vue?vue&type=template&id=b8edf642"
import script from "./matching-schedule-buyer.vue?vue&type=script&lang=js"
export * from "./matching-schedule-buyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports